module.exports = __webpack_public_path__ + "files/7bcb40764b67b2c251a1e7de0805d363.png";